import React, { FC } from 'react';
import { Button as MuiButton, Theme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

interface StyleProps {
  shallow?: boolean;
  smallLabel?: boolean;
}

const baseStyles = createStyles({
  base: {
    borderRadius: '3px',
    fontWeight: 'bold',
    letterSpacing: 0,
    opacity: 1,
  },
});

const buttonStyles = createStyles({
  primary: (props: StyleProps) => ({
    ...baseStyles.base,
    backgroundColor: '#FFC851',
    color: '#253559',
    boxShadow: props.shallow
      ? '0px 2px 4px #00000029'
      : '0px 2px 10px #00000029',
    fontSize: props.smallLabel ? '14px' : '16px',
    '&:hover': { backgroundColor: '#FEAD29' },
    '&:active': { backgroundColor: '#DE8C00' },
    '&:focus': { backgroundColor: '#FEAD29' },
    '&.Mui-disabled': { color: '#253559', opacity: 0.5 },
  }),
  secondary: {
    ...baseStyles.base,
    background: 'transparent',
    color: '#FFFFFF',
    border: '1px solid #FFFFFF',
    fontSize: '16px',
    '&:hover': {},
    '&:active': {},
    '&:focus': {},
    '&.Mui-disabled': { color: '#FFFFFF', opacity: 0.5 },
  },
});

const useStyles = makeStyles<Theme, StyleProps>(buttonStyles);

export type ButtonVariantType = keyof typeof buttonStyles;

export interface ButtonProps extends StyleProps {
  variant?: ButtonVariantType;
  label?: React.ReactNode;
  className?: string;
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

export const Button: FC<ButtonProps> = ({
  variant = 'primary',
  label = 'button',
  shallow = false,
  smallLabel = false,
  disabled = false,
  className = '',
  ...props
}) => {
  const classes = useStyles({ shallow: shallow, smallLabel: smallLabel });

  return (
    <MuiButton
      className={`${classes[variant]} ${className}`}
      disabled={disabled}
      {...props}
    >
      {label}
    </MuiButton>
  );
};
